import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";


// Area Graph
const AreaGraphMonthly = ({ data, title, format, yAxisType }) => {
  let yAxis = {};

  if (yAxisType === "time") {
    yAxis = {
      labels: {
        show: true,
        // formatter: function (val) {
        //   const duration = intervalToDuration({ start: 0, end: val * 1000 });
        //   const label = formatDuration(duration, {
        //     format: ['hours', 'minutes', 'seconds'],
        //     zero: true,
        //     delimiter: "-",
        //     locale: enUS
        //   }); // "1 hour 0 minutes 0 seconds"
        //   return format + label;
        // },

        formatter: function (totalSeconds) {
          const sign = totalSeconds < 0 ? "-" : "";
          const absSeconds = Math.abs(totalSeconds);

          const hours = Math.floor(absSeconds / 3600);
          const minutes = Math.floor((absSeconds % 3600) / 60);
          const seconds = absSeconds % 60;

          return sign + [
            hours.toString().padStart(2, "0"),
            minutes.toString().padStart(2, "0"),
            seconds.toString().padStart(2, "0")
          ].join(":");
        },

      }

    };
  } else {
    yAxis = {
      labels: {
        show: true,
        formatter: function (val) {
          return format + val;
        },
      }

    };
  }
  const [chartData, setChartData] = useState({
    series: [
      {
        name: title,
        data: [],
      },
    ],
    options: {
      chart: {
        height: 250,
        type: "area",
        zoom: {
          enabled: true,
          // Enable x-axis zooming
          type: "x",
          autoScaleYaxis: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      title: {
        text: title,
        align: "left",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        labels: { show: false },
      },
      // yaxis: {
      //   labels: {
      //     show: true,
      //     formatter: function (val) {
      //       return format + val;
      //     },
      //   },
      // },
      yaxis: yAxis
    },
  });

  // set the values for area graph based on props
  useEffect(() => {
    if (data?.recordcounts && data?.dates) {
      setChartData((prevGraphData) => ({
        ...prevGraphData,
        series: [
          {
            ...prevGraphData.series[0],
            data: data?.recordcounts,
            // added for updating the title on title prop change
            name: title
          },
        ],
        options: {
          ...prevGraphData.options,
          title: {
            ...prevGraphData.options.title,
            // Update chart title
            text: title,
          },
          xaxis: {
            ...prevGraphData.options.xaxis,
            categories: data?.dates,
          },
        },
      }));
    }
  }, [data, title, format, yAxisType]);

  return (
    <ReactApexChart
      options={chartData.options}
      series={chartData.series}
      type="area"
      height={310}
    />
  );
};

export default AreaGraphMonthly;
